import React, { useEffect, useContext } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { TableRow } from '@material-ui/core'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../context/DailyMonitoringDetailsFiltersContext'
import EmptyCellsSmall from '../../../../../components/EmptyCellSmall'
import DefaultTableCellSmallSpace from '../../../../../components/DefaultTableCellSmallSpace'
import { GET_ACTIVATION } from '../../../../../queries/dailyMonitoring'
import { getDaysInMonth, DaysInMonth } from '../../../../../utils/Helpers'
import { defaultFormatMonthTimeZone } from '../../../../../utils/consts'

const title = 'QTD Ativ. Novas'
export default function DailyActivation (): JSX.Element {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ACTIVATION, {
      notifyOnNetworkStatusChange: true
    }
  )
  useEffect(() => {
    const activated_at: any = {
      initialDate: `${filters.date.year}-${filters.date.month}||/M`,
      finalDate: `${filters.date.year}-${filters.date.month}||/M`,
      ...defaultFormatMonthTimeZone
    }

    getData({
      variables: { filters: { pharmacyGlobalConfigStates: filters.states, pharmacyGlobalConfigCities: filters.cities, activatedAt: activated_at } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <EmptyCellsSmall title={title} />
  if (loading || !data) return <EmptyCellsSmall title={title} />
  if (error) return <EmptyCellsSmall title={title} />
  if (!data.aggregation?.aggregations?.activations) return <EmptyCellsSmall title={title} />

  const { buckets } = data.aggregation?.aggregations?.activations

  return (
    <TableRow>
      <DefaultTableCellSmallSpace style={{ fontSize: 12 }}>{title}</DefaultTableCellSmallSpace>
      {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
        const bucket = buckets.filter((b: any) => moment.parseZone(String(b.key_as_string)).isSame(moment(day.date, 'DD/MMM/YYYY'), 'day'))[0]
        return !isEmpty(bucket) ? <DefaultTableCellSmallSpace style={{ fontSize: 12 }} key={`${bucket.key_as_string}-${bucket.doc_count}`}>{bucket.doc_count}</DefaultTableCellSmallSpace> : <DefaultTableCellSmallSpace>-</DefaultTableCellSmallSpace>
      })}
    </TableRow>
  )
}
